<template>
    <div class="position-box propagate">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('tibi.title')}}</div>
            <img class="record" v-if="theme" src="@/assets/theme/jilu.png" @click="record" alt="">
            <img class="record" v-else src="@/assets/dingdan.png" @click="record" alt="">
        </div>
        <div class="cotainer withdraw">
            <div class="select-box" @click="select" v-if="lang == 'ar'">
              <img class="arrow" v-if="theme" style="margin: 0 .3rem 0 0" src="@/assets/theme/icon_back.png" alt="">
              <img class="arrow" v-else style="margin: 0 .3rem 0 0" src="@/assets/alb/icon_back.png" alt="">
              <div class="t2">{{$t('bzxz.title')}}</div>
              <div class="t1">{{currency}}</div>
            </div>
            <div class="select-box" @click="select" v-else>
                <div class="t1">{{currency}}</div>
                <div class="t2">{{$t('bzxz.title')}}</div>
                <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
            </div>
            <div class="bank-box" v-show="currency == 'USDT' && hasBank == 1">
                <input class="checkbox" id="checkbox" v-model="check" type="checkbox">
                <div class="text"><label for="checkbox">{{$t('tibi.yhktx')}}</label></div>
            </div>
            <template v-if="check && hasBank == 1">
                <div class="tips">{{$t('tibi.yhmc')}}</div>
                <div class="input-box"><input class="input" v-model="bank_info" type="text" :placeholder="$t('tibi.qsryhmc')"></div>
                <div class="tips">{{$t('tibi.yhzh')}}</div>
                <div class="input-box"><input class="input" v-model="bank_no" type="number" :placeholder="$t('tibi.qsryhzh')"></div>
                <div class="tips">{{$t('tibi.gjhkdm')}}</div>
                <div class="input-box"><input class="input" v-model="bank_code"  type="text" :placeholder="$t('tibi.qsrgjhkdm')"></div>
                <div class="tips">{{$t('tibi.yhdz')}}</div>
                <div class="input-box"><input class="input" v-model="bank_address"  type="text" :placeholder="$t('tibi.qsryhdz')"></div>
                <div class="tips">{{$t('tibi.skrxm')}}</div>
                <div class="input-box"><input class="input" v-model="bank_user_name"  type="text" :placeholder="$t('tibi.qsrskrxm')"></div>
                <div class="tips">{{$t('tibi.skrdh')}}</div>
                <div class="input-box"><input class="input" v-model="bank_user_phone"  type="number" :placeholder="$t('tibi.qsrskrdh')"></div>
                <div class="tips">{{$t('tibi.skrdz')}}</div>
                <div class="input-box"><input class="input" v-model="bank_user_address"  type="text" :placeholder="$t('tibi.qsrskrdz')"></div>
            </template>
            <div class="tips" v-show="!check">{{$t('chongzhi.t7')}}</div>
            <ul class="chain-box" v-show="!check">
                <li class="chain" :class="{active: tabIdx == index}" v-for="(item,index) in addressList" :key="index" @click="change(item.value,index)">{{item.value}}</li>
            </ul>
            <div class="tips" v-show="!check">{{$t('tibi.t1')}}</div>
            <div class="input-box" v-show="!check"><input class="input" v-model="address" type="text" :placeholder="$t('tibi.t2')"><!--<img class="scan" src="@/assets/user/scan.png" @click="copy($event)" alt="">--></div>
            <div class="tips" v-show="currency == 'EOS' || currency == 'XRP'">{{$t('tibi.bq')}}</div>
            <div class="input-box" v-show="currency == 'EOS' || currency == 'XRP'"><input class="input" type="text" :placeholder="$t('tibi.qsrbq')"></div>
            <div class="tips">{{$t('tibi.t3')}}</div>
            <div class="input-box"><input class="input" v-model="amount" type="number" @input="input" min="0" @keyup="keyMoney()" :placeholder="$t('tibi.t4') + ' ' + c_tb_money"><div class="t1"></div><!-- <div class="t2" @click="all">{{$t('hyjy.qb')}}</div>--></div>
            <!-- <div class="tips-ky">{{$t('hyjy.ky')}} {{account}} {{currency}}</div> -->
            <div class="tips" v-show="rate.split('%')[0] > 0">{{$t('tibi.t7')}}</div>
            <div class="input-box" v-show="rate.split('%')[0] > 0"><input class="input" readonly type="text" placeholder="" v-model="rate"><div class="fee-text"></div></div>
            <!-- <div class="tips-box">
                <div class="text">24h提现额度：1014545.10 USDT</div>
                <div class="text">最小提币数量：100.0 USDT</div>
                <div class="text">请勿直接提现至众筹ICO地址,我们不会处理未来代币的发放</div>
            </div> -->
            <div class="tips">{{$t('tibi.t8')}}</div>
            <div class="input-box"><input class="input" v-model="sjAmount" type="number" disabled><div class="t1"></div><div class="t2">{{currency}}</div></div>
        </div>
        <button class="btn-login btn-bg" @click="sure">{{$t('tibi.t9')}}</button>
        <div class="mask" v-show="!yszPwd"></div>
        <div class="alert-tips-box" v-show="!yszPwd">
            <div class="title">{{$t('sztkmm.sztkts')}}</div>
            <div class="btn btn-bg" @click="jump">{{$t('sztkmm.qd')}}</div>
        </div>
        <div class="mask" v-show="isShow"></div>
        <!-- 密码框 -->
        <div class="alert-pwd-box" v-show="isShow">
             <img class="close" src="@/assets/close2.png" @click="close" alt="">
            <div class="alert-head">{{$t('tips.qsrjymm')}}</div>
            <ul class="pwd-box">
                <li class="pwd" v-for="(item,index) in inputList" :key="index"><input class="input pwd-input" v-model="item.val" type="password" maxlength="1" oninput = "value=value.replace(/[^\d]/g,'')" @keyup="nextFocus($event,index)" inputmode="numeric" autocomplete="off"></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'deposit',
    data () {
        return {
            theme: false,
            isPay: false,
            yszPwd: true,//是否设置密码
            type: 1,
            tabIdx: 0,
            check: false,
            currency: '',
            chain: '',
            addressList: [],
            rate: '',//手续费
            c_tb_money: '',//最低提币
            amount: '',
            address: '',
            account: '',//可用
            sjAmount: '',//实际到账数量,
            inputList: [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}],
            is_bank: 0,
            bank_info: '',
            bank_no: '',
            bank_code: '',
            bank_address: '',
            bank_user_name: '',
            bank_user_phone: '',
            bank_user_address: '',
            hasBank: '',
            isShow: false,
            count: 1,
            lang: 'en'
        }
    },
    created(){
        this.type = this.$route.query.type || 1;
        this.currency = localStorage.getItem('bz') || 'USDT';
        this.theme = JSON.parse(localStorage.getItem('theme'));
        this.lang = localStorage.getItem('language') || 'en';
    },
    mounted() {
        this.hasTpassword();
        this.hasBankinfo();
        this.getChainList();
        this.getWalletLine();
        // this.getAsset();
    },
    methods: {
      back(){
          this.$router.push('/user')
      },
      jump(){
          this.$router.push('/setWithdrawPwd')
      },
      record(){
          this.$router.push({ path: '/withdrawRecords', query: { idx: 1 } })
      },
      select(){
          this.$router.push({ path: '/selectCurrency', query: { type: 1,url: 'withdraw' } })
      },
      copy(e){
        let address = this.address;
        this.$copyText(address, this.$t('kjmb.fzcg'));
        this.$toast.center(this.$t('kjmb.fzcg'));
      },
      change(chain,idx){
          this.tabIdx = idx;
          this.chain = chain;
      },
      all(){
        this.amount = this.account;
      },
      getAsset(){
        this.$ajax.get('/web/getAsset2',{}).then((res) => {
            let resData = res.data.data;
            this.account = resData.list.filter((item) =>{
                return item.currency == this.currency;
            })[0].positions
        }).catch(function(err){
            console.log(err)
        })
      },
      hasBankinfo(){
        this.$ajax.get('/web/hasBankinfo',{}).then((res) => {
              let resData = res.data.data;
              this.hasBank = resData;
          }).catch(function(err){
              console.log(err)
          })
      },
      hasTpassword(){
          this.$ajax.get('/web/hasTpassword',{}).then((res) => {
              let resData = res.data.data;
              if(resData == 0){
                  this.yszPwd = false;
                  // this.$toast.center(this.$t('tips.jymmts'));
                  return;
              }else{
                  this.yszPwd = true
              }
          }).catch(function(err){
              console.log(err)
          })
      },
      getChainList(){
          let params = {
              currency: this.currency
          }
          this.$ajax.get('/web/getChainList',{params}).then((res) => {
              let resData = res.data.data;
              if(resData.length > 0){
                  this.addressList = resData;
                  this.chain = resData[0].value;
              }else{ //暂未开放充值
                  // this.$router.push('/user')
              }
          }).catch(function(err){
              console.log(err)
          })
      },
      getWalletLine(){
          let params = {
              currency: this.currency
          }
          this.$ajax.get('/web/getWalletLine',{params}).then((res) => {
              let resData = res.data.data;
              if(res.data.code == 1000){
                // this.$toast.center(res.data.message);
                setTimeout(()=>{
                  this.$router.push('/login');
                },1000)
                return false
              }
              this.c_tb_money = resData.c_tb_money;
              this.rate = resData.rate + '%';
          }).catch(function(err){
              console.log(err)
          })
      },
      sure(){
          if(this.check){
          if(this.bank_info == '' || this.bank_info == null){
              this.$toast.center(this.$t('tibi.qsryhmc'));
              return;
          }
          if(this.bank_no == '' || this.bank_no == null){
              this.$toast.center(this.$t('tibi.qsryhzh'));
              return;
          }
          if(this.bank_code == '' || this.bank_code == null){
              this.$toast.center(this.$t('tibi.qsrgjhkdm'));
              return;
          }
          if(this.bank_address == '' || this.bank_address == null){
              this.$toast.center(this.$t('tibi.qsryhdz'));
              return;
          }
          if(this.bank_user_name == '' || this.bank_user_name == null){
              this.$toast.center(this.$t('tibi.qsrskrxm'));
              return;
          }
          if(this.bank_user_phone == '' || this.bank_user_phone == null){
              this.$toast.center(this.$t('tibi.qsrskrdh'));
              return;
          }
          if(this.bank_user_address == '' || this.bank_user_address == null){
              this.$toast.center(this.$t('tibi.qsrskrdz'));
              return;
          }
      }else{
          if(this.address == '' || this.address == null){
              this.$toast.center(this.$t('tibi.t2'));
              return;
          }
      }
      if(this.currency == 'EOS' || this.currency == 'XRP'){
          if(this.tag == '' || this.tag == null){
              this.$toast.center(this.$t('tibi.qsrbq'));
              return;
          }
      }
      if(this.amount == '' || this.amount == null || this.amount <= 0){
          this.$toast.center(this.$t('tibi.qsrtbsl'));
          return;
      }else if(this.amount < parseFloat(this.c_tb_money)){
          this.$toast.center(this.$t('tibi.t4') + this.c_tb_money);
          return;
      }
      if(this.yszPwd){
          this.isShow = true
      }else{
          this.isShow = false;
          this.$toast.center(this.$t('tips.jymmts'));
      }
      },
      nextFocus(el,index) {
          var dom = document.getElementsByClassName("pwd-input"),
              currInput = dom[index],
              nextInput = dom[index + 1],
              lastInput = dom[index - 1];/*这里的keyCode 根据不同的平台或许不同,安卓就是不是8*/
          if(el.keyCode != 8) {
              if(dom[0].value == ''){
                  dom[0].value = this.inputList[0].val = currInput.value;
                  currInput.value = this.inputList[index].val ='';
                  dom[0].blur();
                  dom[1].focus();
              }
              if(currInput.value == '') return;
              if(index < (this.inputList.length - 1)) {
                  nextInput.focus();
              }else {
                  currInput.blur();
              }
            }else{
                if(index != 0) {
                  lastInput.focus();
                }
            }
          let password = this.inputList[0].val +  this.inputList[1].val + this.inputList[2].val + this.inputList[3].val +  this.inputList[4].val + this.inputList[5].val;
          if(password.length == 6){
              let params = {
                  currency: this.currency,
                  address: this.address,
                  number: this.amount,
                  password: password,
                  wid: '',
                  type: this.type,
                  chain: this.chain,
                  tag:  this.tag,
                  is_bank: this.is_bank,
                  bank_info: this.bank_info,
                  bank_no: this.bank_no,
                  bank_code: this.bank_code,
                  bank_address: this.bank_address,
                  bank_user_name: this.bank_user_name,
                  bank_user_phone: this.bank_user_phone,
                  bank_user_address: this.bank_user_address
              }
              if(this.count == 1){
                this.count = 0;
              }else{
                  return false;
              }
              this.$ajax.post('/web/tokeMoney',params).then((res) => {
                  let resData = res.data;
                  if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                      this.$toast.center(resData.message);
                      setTimeout(() => {
                        this.count = 1;
                        this.$router.push({ path: '/withdrawRecords', query: { idx: 1 } })
                      }, 1000)
                  }else{
                    this.count = 1;
                    this.isShow = false;
                    this.inputList = [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];
                    this.$toast.center(resData.message);
                    return;
                  }
              }).catch(function(err){
                  console.log(err)
              })
          }else{
              return false;
          }
      },
      close(){
          this.isShow = false;
          this.inputList = [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];
      },
      input(){
          var walletLine = this.rate.split('%')[0];
          var rate = parseFloat(this.amount) * parseFloat(walletLine) / 100;
          this.sjAmount = parseFloat(parseFloat(this.amount) - rate).toFixed(4);
      },
      keyMoney(){
          this.amount = this.amount.replace(/[^\d.]/g, "");  //仅保留数字和"."
          this.amount = this.amount.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
          this.amount = this.amount.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
          this.amount = this.amount.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
          if (this.amount.indexOf(".") < 0 && this.amount != "") { //首位是0的话去掉
              this.amount = parseFloat(this.amount);
          }
      },
    },
    beforeDestroy(){

    },
    watch: {
      check:function(){
        this.is_bank = this.check ? 1:0;
      },
      amount:function(){
        var walletLine = this.rate.split('%')[0];
        var rate = parseFloat(this.amount) * parseFloat(walletLine) / 100;
        this.sjAmount = parseFloat(parseFloat(this.amount) - rate).toFixed(4);
      }
	},
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .record{
        position: absolute;
        top: 50%;
        right: .3rem;
        width: .6rem;
        height: .6rem;
        margin-top: -.3rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 2rem;
        width: 100%;
        padding: 0 .48rem;
        background: #fff;
        box-sizing: border-box;
        overflow-y: scroll;
    }
    .select-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 1.3rem;
        margin: .48rem 0 0;
        padding: 0 .44rem;
        background: #f9f9f9;
    }
    .select-box .t1{
        flex: 1;
        color: #000;
        font-size: .48rem;
    }
    .select-box .t2{
        color: #a9a9a9;
        font-size: .4rem;
    }
    .select-box .arrow{
        width: .2rem;
        margin-left: .3rem;
    }
    .bank-box{
        display: flex;
        align-items: center;
        margin-top: .6rem;
    }
    .bank-box .text{
        padding: 0 .2rem;
        color: #000;
        font-size: .4rem;
    }
    .tips{
        padding: .6rem 0 .26rem;
        color: #000;
        font-size: .4rem;
    }
    .tips-ky{
        padding: .4rem 0 0;
        color: #747474;
        font-size: .34rem;
    }
    .chain-box{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        margin-top: .3rem;
    }
    .chain-box .chain{
        width: 2.59rem;
        height: 0.96rem;
        margin: 0 .4rem .4rem 0;
        color: #a9a9a9;
        font-size: .4rem;
        line-height: .96rem;
        background-color: #f7f7f7;
        border-radius: 0.48rem;
        text-align: center;
    }
    .chain-box .chain.active{
        color: #fff;
        background-color: #588bf8;
    }
    .input-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #ececec;
    }
    .input-box .input{
        flex: 1;
        padding: .32rem 0;
        font-size: .4rem;
    }
    .input-box .input::placeholder{
        color: #d7d7d7;
        font-size: .42rem;
    }
    .input-box .t1{
        /* padding: 0 .3rem; */
        color: #a6a6a6;
        font-size: .48rem;
        /* border-right: 1px solid #d7d77d; */
    }
    .input-box .t2{
        padding-left: .3rem;
        color: #000;
        font-size: .48rem;
    }
    .input-box .scan{
        width: .58rem;
        height: .58rem;
    }
    .input-box .fee-text{
        color: #a6a6a6;
        font-size: .48rem;
    }
    .tips-box{
        margin-top: .4rem;
        padding: .52rem .34rem .2rem;
        background: #f9f9f9;
    }
    .tips-box .text{
        padding-bottom: .36rem;
        color: #50545b;
        font-size: .34rem;
    }
    .num-tip{
        display: flex;
        justify-content: space-between;
        align-items: stretch;
        padding: 1.1rem 0 1rem;
    }
    .num-tip .t1{
      width: 60%;
      color: #3b4250;
      font-size: .48rem;
    }
    .num-tip .t2{
        color: #000;
        font-size: .48rem;
    }
    .btn-login{
        position: fixed;
        left: .44rem;
        right: .44rem;
        bottom: .42rem;
        width: 9.92rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/withdraw.vue